module.exports = __webpack_public_path__ + "static/media/ca_1.a3fe6983.png";